/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-07-09 17:33:12
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-22 00:16:33
 */

import { Injectable } from "@angular/core";

import { ENV } from "../env/env";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class AdminService {
  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/admin`;

  constructor(private http: HttpClient) {}

  getLogs(page: number, type: string, date: string) {
    return this.http.get(
      `${this.url}/logs?page=${page}&type=${type}&date=${date}`
    );
  }

  getLogPushes(page: number, date: string) {
    return this.http.get(`${this.url}/log-pushes?page=${page}&date=${date}`);
  }

  getData(name: string) {
    return this.http.get(`${this.url}/data/${name}`, { responseType: "blob" });
  }

  dumpdb() {
    return this.http.get(`${this.url}/dumpdb`, { responseType: "blob" });
  }

  restoreDB(file: any) {
    const formData = new FormData();
    formData.append("zip", file);
    const headers = new HttpHeaders({
      "my-content-type": "application/form-data"
    });
    return this.http.post(`${this.url}/restoredb`, formData, {
      headers: headers
    });
  }

  sendPush(message: string) {
    return this.http.put(`${this.url}/push`, {
      message: message
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/admin.service.ts